import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import CleanPageBanner from "../../../../components/customer/pagebanner/PageBanner";
import ShopDetailPage from "../../../../components/customer/ShopDetailPage/ShopDetailPage";
import CategorySidebar from "../../../../subscreens/customer/category/categorysidebar/CategorySidebar";
import CategoryHeader from "../../../../subscreens/customer/category/categoryheader/CategoryHeader";
import ProductsGrid from "../../../../subscreens/customer/category/productsgrid/ProductsGrid";
import Pagination from "../../../../components/customer/pagination/Pagination";
import "../../../../assets/css/customer/subscreens/category/CategoryPage.css";
import MyContext from "../../../../contexts/AppContext";
import { useLocation } from "react-router-dom";

const CategoryPage = () => {
  const {
    baseUrl,
    selectedShop,
    setSelectedProductForCustomer,
    selectedCategory,
      setSelectedShop,
    setSelectedCategory,
  } = useContext(MyContext);
  const shopData = selectedShop;
  const isShopView = !!(shopData && shopData.id);
  const sellerId = shopData?.id ?? null;
  const [priceRange, setPriceRange] = useState([0, 10000]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [categories, setCategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
const location = useLocation();
  // ── Fetch categories ──
  const viewAllCategories = () => {
    axios
      .get(`${baseUrl}/customer/category/viewAllCategories`)
      .then((response) => {
        setCategories(response.data.categories);
      })
      .catch((error) => console.log(error));
  };

  // ── Fetch products — seller filter ──
const viewAllProducts = () => {
    setLoading(true);
    axios
      .get(`${baseUrl}/customer/product/viewAllProducts`)
      .then((response) => {
        let products = response.data.products;

        console.log("shopData:", shopData);
        console.log("sellerId:", sellerId, typeof sellerId);
        if (products.length) {
          console.log("first product seller_id:", products[0].seller_id, typeof products[0].seller_id);
        }

        if (isShopView && sellerId) {
          products = products.filter(
            (p) => String(p.seller_id) === String(sellerId)
          );
        }

        setAllProducts(products);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    viewAllCategories();
    viewAllProducts();
  }, []);

  useEffect(() => {
    if (!isShopView || !allProducts.length) return;

    const sellerCategoryIds = new Set(
      allProducts.map((p) => p.category_id).filter(Boolean),
    );

    setCategories((prev) =>
      prev.filter((cat) => sellerCategoryIds.has(cat.id)),
    );
  }, [allProducts, isShopView]);

  // ── Filter logic ──
  // ── Filter logic ──
  const filteredProducts = allProducts.filter((product) => {
    const productCategoryName = product.category?.category_name ?? null;
    const matchesCategory =
      selectedCategory === "All Products" ||
      productCategoryName === selectedCategory?.name ||
      productCategoryName === selectedCategory;

    const productSubcategoryName = product.subcategory?.subcategoryname ?? null;
    const matchesSubcategory =
      !selectedSubcategory || productSubcategoryName === selectedSubcategory;

    const price = parseFloat(product.price);
    const matchesPrice = price >= priceRange[0] && price <= priceRange[1];

    const matchesSearch = product.product_name
      ?.toLowerCase()
      .includes(searchQuery.toLowerCase());

    return (
      matchesCategory && matchesSubcategory && matchesPrice && matchesSearch
    );
  });
  // ── Pagination ──
  const productsPerPage = 12;
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);
  const startIndex = (currentPage - 1) * productsPerPage;
  const displayedProducts = filteredProducts.slice(
    startIndex,
    startIndex + productsPerPage,
  );

  const handleCategoryChange = (cat) => {
    setSelectedCategory(cat);
    setSelectedSubcategory(null);
    setCurrentPage(1);
  };

  const handleSearchChange = (val) => {
    setSearchQuery(val);
    setCurrentPage(1);
  };

  const toggleBrand = (brand) => {
    setSelectedBrands((prev) =>
      prev.includes(brand) ? prev.filter((b) => b !== brand) : [...prev, brand],
    );
  };

  const toggleTag = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag],
    );
  };

  const getBreadcrumb = () => {
    const parts = ["Home", "Categories"];
    if (selectedCategory !== "All Products") parts.push(selectedCategory);
    return parts;
  };
useEffect(() => {
  if (location.pathname === "/categories") {
    setSelectedShop(null);
    localStorage.removeItem("selectedShop"); // 👈 add karo
  }
}, [location.pathname]);
  return (
    <div className="category-page-container">
      {!isShopView && (
        <CleanPageBanner
          title="Categories"
          subtitle="Browse through our extensive collection organized by style"
          buttonText="View All"
          buttonLink="#categories"
          breadcrumbs={[{ label: "Categories" }]}
        />
      )}

      {isShopView && <ShopDetailPage />}

      <div className="category-page-content">
        <CategorySidebar
          setSelectedCategory={handleCategoryChange}
          searchQuery={searchQuery}
          setSearchQuery={handleSearchChange}
          categories={categories}
          selectedCategory={selectedCategory}
          selectedSubcategory={selectedSubcategory}
          setSelectedSubcategory={setSelectedSubcategory}
          selectedBrands={selectedBrands}
          toggleBrand={toggleBrand}
          selectedTags={selectedTags}
          toggleTag={toggleTag}
          priceRange={priceRange}
          setPriceRange={setPriceRange}
        />

        <main className="category-main-content">
          <CategoryHeader
            breadcrumb={getBreadcrumb()}
            displayedProductsLength={displayedProducts.length}
            filteredProductsLength={filteredProducts.length}
            isShopView={isShopView}
            shopData={shopData}
          />

          {loading ? (
            <div className="products-loading">
              <p>Loading products...</p>
            </div>
          ) : filteredProducts.length === 0 ? (
            <div className="products-empty">
              <p>No products found.</p>
            </div>
          ) : (
            <ProductsGrid products={displayedProducts} />
          )}

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
          />
        </main>
      </div>
    </div>
  );
};

export default CategoryPage;
